// This icon file is generated automatically.
var PUserOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.41 10.93A5.84 5.84 0 009.3 7.8h-.02a3.87 3.87 0 10-4.54 0h-.02a5.82 5.82 0 00-3.12 3.13 5.8 5.8 0 00-.47 2.16c0 .07.06.13.13.13h.94c.07 0 .12-.06.12-.12A4.66 4.66 0 017 8.53a4.66 4.66 0 014.69 4.57c0 .07.05.12.12.12h.94c.07 0 .13-.06.13-.13a5.82 5.82 0 00-.47-2.16zM7 7.34a2.67 2.67 0 01-2.69-2.68A2.67 2.67 0 017 1.96a2.67 2.67 0 012.69 2.7A2.67 2.67 0 017 7.34z", "fill-rule": "nonzero" } }] }, "name": "p-user", "theme": "outlined" };
export default PUserOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PUserOutlined.js
// module id = 3712
// module chunks = 0